import { render, staticRenderFns } from "./Renamed.vue?vue&type=template&id=b71e22a0"
import script from "./Renamed.vue?vue&type=script&lang=js"
export * from "./Renamed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports